import { Alert, AlertIcon, Heading, Stack, Text } from "@chakra-ui/react";

import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { MutedLink } from "../../../components/shared/MutedLink";
import { Routes } from "../../../constants";
import { useAuth } from "../../../providers/AuthProvider";
import AuthSignInForm from "../forms/AuthSignInForm";
import { env } from "process";

export interface SignInError {
  key?: string;
  status: string;
}

const AuthSignIn = () => {
  let location = useLocation();
  const locationState = location.state as any;

  const [showResend, setShowResend] = useState(false);
  const { login, refetchUserProfile } = useAuth();
  const navigate = useNavigate();

  const handleFormSubmit = async (username: string, password: string) => {

     if(env.REACT_APP_LOCAL_API_ENDPOINT) {
      let goToApp = "/app/dashboard";

      navigate(goToApp);
      return;
     }




    try {
      await login(username, password);

      let trial_expiration_date = (await refetchUserProfile()).data
        ?.trial_expiration_date;

      if (trial_expiration_date != null) {
        const today = new Date(new Date().toISOString().slice(0, 10));
        const expiration = new Date(trial_expiration_date);

        if (today > expiration) {
          throw new Error("Account has expired");
        }
      }

      let goToApp = "/app/dashboard";

      navigate(goToApp);
    } catch (error: any) {
      // Parse cognito responses
      let err: SignInError = {
        status: "Sign in failed",
      };
      if (error.code === "UserNotFoundException") {
        err = {
          key: "email",
          status: "Email not found",
        };
      } else if (error.code === "NotAuthorizedException") {
        err = {
          key: "password",
          status: "Please try password again",
        };
      } else if (error.code === "UserNotConfirmedException") {
        err = {
          status: "Please confirm your email",
        };
        setShowResend(true);
      } else if (error.message === "Account has expired") {
        err = {
          status: "Your account has expired, please contact support",
        };
      }
      throw err;
    }
  };

  return (
    <Stack spacing={16}>
      <Stack>
        <Heading color={"text.main"} as="h1" size="xl">
          Login
        </Heading>
        <Text color={"text.softer"} fontSize="xl">
          Welcome back! Please log in to view your registries.
        </Text>
      </Stack>

      {/* Form */}
      <Stack spacing={6}>
        {locationState?.isResetPasswordSuccess && (
          <Alert status="success" variant={"solid"}>
            <AlertIcon />
            Password reset successfully
          </Alert>
        )}

        {/* SignIn Form */}
        <AuthSignInForm
          username={locationState?.username}
          handleFormSubmit={handleFormSubmit}
        ></AuthSignInForm>

        {/* Actions */}
        <Stack>
          {/* Resend confirmation code */}
          {showResend ? (
            <MutedLink
              to={Routes.AuthResendEmailConfirmation}
              label="Resend confirmation code"
            ></MutedLink>
          ) : null}

          {/* Forgot password */}
          <MutedLink
            to={Routes.AuthResetPassword}
            label="Forgot your password?"
          ></MutedLink>
          <MutedLink
            to={Routes.StatsDashboard}
            label="View Public Dashboard"
          ></MutedLink>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AuthSignIn;
